 (function(){
  'use strict';
  // tool
  var utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
  }
  var Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = null;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = '{{amount}} €';
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = utils.defaultTo(precision, 2);
        thousands = utils.defaultTo(thousands, ',');
        decimal = utils.defaultTo(decimal, ',');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes('.')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();
      
  var options =  {
    singleOptionSelector: '[data-variant-input]',
    variantsJson: '[data-variant-json]',
    originalSelectorId: '[data-product-select]',
  }
  // defautl int
  var variantJson = document.querySelector(options.variantsJson);
  var variantsObject = JSON.parse(variantJson.innerHTML);;
  var currentlySelectedValues = _getCurrentOptions();
  var currentVariant = _getVariantFromOptions(currentlySelectedValues);
      
  document.querySelectorAll(options.singleOptionSelector).forEach(el => {
    el.addEventListener('change', _onSelectChange.bind(this));
  });
  function compact(array) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  };
  function _getCurrentOptions() {
    var result = [];

    document.querySelectorAll(options.singleOptionSelector).forEach(el => {
      var type = el.getAttribute('type');

      if (type === 'radio' || type === 'checkbox') {
        if (el.checked) {
          result.push({
            value: el.value,
            index: el.dataset.index
          });
        }
      } else {
        result.push({
          value: el.value,
          index: el.dataset.index
        });
      }
    });

    // remove any unchecked input values if using radio buttons or checkboxes
    result = compact(result);
    return result;
  };
  function _updateMasterSelect(variant) {
    document.querySelector(options.originalSelectorId).value = variant.id;
    // Force a change event so Shop Pay installments works after a variant is changed
    // document.querySelector(options.originalSelectorId).dispatchEvent(new Event('change', { bubbles: true }));
  };
  function _updatePrice(variant) {
    var selectors = {
      price: '[data-mdv-price]',
      comparePrice: '[data-mdv-compare-at-price]',
    };
    if (currentVariant && variant.price === currentVariant.price && variant.compare_at_price === currentVariant.compare_at_price) {
      return;
    }
    if(variant) {
       document.querySelector(selectors.price).innerHTML = Currency.formatMoney(variant.price);
    }
  };
  function _getVariantFromOptions(selectedValues) {
    var variants = variantsObject;
    var found = false;

    if (selectedValues.length !== variants[0].options.length) return null;

    variants.forEach(function(variant) {
      var match = true;
      var options = variant.options;

      selectedValues.forEach(function(option) {
        if (match) {
          match = (variant[option.index] === option.value);
        }
      });

      if (match) {
        found = variant;
      }
    });

    return found || null;
  };

  function _updateImages(variant) {
    var variantImage = variant.featured_image || {};
    var currentVariantImage = currentVariant && currentVariant.featured_image || {};
    if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
      return;
    };
    // updateVariantImage
    var newImage = document.querySelector('[data-product-slider-control][data-id="' + variant.featured_media.id + '"]');
    if (newImage) {
      newImage.click();
    }
  }
  
  function _onSelectChange(evt) {
    var el = evt.srcElement
    var type = el.getAttribute('type');

    if (el.classList.contains('disabled')) {
      this.container.querySelectorAll(this.singleOptionSelector).forEach(input => {
        if (type === 'radio' || type === 'checkbox') {
          if (input !== el) {
            input.checked = false
          }
        }
      })
    };
    currentlySelectedValues = _getCurrentOptions();
    var variant = _getVariantFromOptions(currentlySelectedValues);

    if (!variant) {
      return;
    };
    _updateMasterSelect(variant);
    _updateImages(variant);
    _updatePrice(variant);
    currentVariant = variant;
  };

  // 商品详情页提示信息
  function getDateStr(AddDayCount) { 
      var monthMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var dd =  new Date();
      dd.setDate(dd.getDate()+AddDayCount); //获取AddDayCount天后的日期
      var m = dd.getMonth()+1; //获取当前月份的日期，不足10补0
      var d = dd.getDate();
      return monthMap[m-1]+ "&nbsp;" +d; 
  };
  document.querySelectorAll(".delivery-date").forEach(function(el) {
    const isPresale = el.getAttribute('data-presale');
    if(isPresale == 'true') {
      el.innerHTML = getDateStr(7) + "-" + getDateStr(15);
    } else {
      el.innerHTML = getDateStr(2) + "-" + getDateStr(5);
    }
  })
  
})();